import styled from "styled-components";

export const StyledCell = styled.td`
    border: 0.5px dotted gray;
    width: 25px;
    height: 25px;
    border-radius: 20px;
`;